import {GET_ARCHIVED_DETAILS,GET_BALANCESHEET_DETAILS,UPDATE_CUSTOM_FILEDS,GET_EDIT_ARCHIED_DATA,GET_GLReviewLastQueterDate,GET_BSACCOUNTS_RECONCILE,ACCOUNT_INACTIVE} from "../actions/BalanceSheetAction";
const initial_state ={
    BalanceSheetData :null,
    ArchivedData:null,
    UpdateData:null,
    EditArchivedData:null,
    GLReviewLastQueterDate:null,
    BSAccountsReconcileData:null,
    AccountInactive:null
};


export default function authReducer(state = initial_state, action) {
    switch (action.type) {
        case GET_BALANCESHEET_DETAILS:
            return { ...state, BalanceSheetData: action.payload.data };
        case GET_ARCHIVED_DETAILS:
            return { ...state,ArchivedData:action.payload.data };
        case UPDATE_CUSTOM_FILEDS:
            return  { ...state,UpdateData:action.payload.data };
        case GET_EDIT_ARCHIED_DATA :
            return {...state,EditArchivedData:action.payload.data};
        case GET_GLReviewLastQueterDate :
            return {...state,GLReviewLastQueterDate:action.payload.data};
        case GET_BSACCOUNTS_RECONCILE:
            return { ...state, BSAccountsReconcileData: action.payload.data };
        case ACCOUNT_INACTIVE:
            return { ...state, AccountInactive: action.payload.data };
        default: 
            return state;
    }
}
